import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'fgb-ace-jump-layout-page',
  templateUrl: './ace-jump-layout-page.component.html',
  styleUrl: './ace-jump-layout-page.component.scss',
})
export class AceJumpLayoutPageComponent implements OnInit {
  private router = inject(Router);
  private translate = inject(TranslateService);
  private featureFlagKey = 'feature.flag.ace.jump.leaderboard';
  private destroyRef = inject(DestroyRef);
  isLeaderboardEnabled: boolean = false;

  ngOnInit(): void {
    this.translate
      .stream(this.featureFlagKey)
      .pipe(
        map((translation) => translation.toLocaleLowerCase() === 'true'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((isEnabled) => {
        this.isLeaderboardEnabled = isEnabled;
      });
  }

  get isLeaderboard(): boolean {
    return this.router.isActive('/games/acejump/leaderboard', {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
